import {
  Box,
  Text,
} from '@chakra-ui/react';
import React from 'react';
import { getUsefulVars } from '../../../handlers/helpers';

const PreviewCareer = ({ myData,props }) => {
  let downloadText = ' ';
  if (myData.download !== undefined) {
    if (myData.download[0] === undefined || myData.download[0]['D1'] === undefined) {
      myData.download.push({ D1: '' });
    } else {
      downloadText = myData.download[0]['D1'];
    }

  }
  const uv = getUsefulVars(props);
  return (
    <Box className="contentBox">
      <Box>
        <Text>{downloadText}</Text>
      </Box>
    </Box>
  );
};
export default PreviewCareer;

/*

        <Editable
        className='editableWork'
        autoResize
        defaultValue={downloadText}
      >

        <EditablePreview />
        <EditableTextarea onBlur={(e) => freeFormEditCareerSummary(e, uv)}
        />
      </Editable>
        */